import React from 'react'
import createMarkup from '../../../helpers/createMarkup'
import { Row, Col, } from 'reactstrap'

export default function ItemFeedback (props) {
  let markup
  if (props.feedback) {
    markup = createMarkup(props.feedback)
  }
  let feedback = null
  if (props.completed) {
    feedback = <div dangerouslySetInnerHTML={markup}></div>
  }

  return (
    <Row className='mt-1'>
      <Col>
        {feedback}
        {props.videoFeedback && props.completed && (props.videoFeedbackThumbnail 
          ? <img onClick={props.toggleModal} className="img-fluid open-modal-card" src={props.videoFeedbackThumbnail} alt="Watch Video Explanation" /> 
          : <div onClick={props.toggleModal} className="text-center open-modal-card">Watch Video Explanation</div>) 
        }
      </Col>
    </Row>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessTest/ItemFeedback.js